import React from 'react';

import { margin } from '@lumapps/classnames';
import { mdiReload } from '@lumapps/lumx/icons';
import {
    Alignment,
    Button,
    Emphasis,
    FlexBox,
    Message,
    Orientation,
    Placement,
    Size,
    Text,
    Typography,
} from '@lumapps/lumx/react';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import { ASK_AI } from '../../keys';

interface AskAiAuthorizationSuccessCardProps {
    /** Method used to remake an Ask AI query */
    refetch?: () => void;
}

/**
 * Component displayed in an Ask AI answer if an authErrored connector has been connected.
 * It displays a message and a reload button meant to re make the initial Ask AI query.
 *
 * @param {AskAiAuthorizationSuccessCardProps} props - Optional `refetch` method.
 * @returns {AskAiAuthorizationSuccessCard} - The rendered component.
 */
export const AskAiAuthorizationSuccessCard = ({ refetch }: AskAiAuthorizationSuccessCardProps) => {
    const { translateKey } = useTranslate();
    return (
        <Message
            kind="success"
            hasBackground
            style={{ alignItems: 'center' }} // This style ensures the icon is properly aligned
        >
            <FlexBox orientation={Orientation.horizontal} hAlign={Alignment.center} vAlign={Alignment.spaceBetween}>
                <Text as="p" typography={Typography.body1} className={margin(Placement.RIGHT, Size.regular)}>
                    {translateKey(ASK_AI.AUTHORIZATION_SUCCESS_MESSAGE)}
                </Text>
                {refetch && (
                    <Button leftIcon={mdiReload} onClick={refetch} emphasis={Emphasis.medium}>
                        {translateKey(GLOBAL.RELOAD)}
                    </Button>
                )}
            </FlexBox>
        </Message>
    );
};
